import { render, staticRenderFns } from "./DataFiltro.vue?vue&type=template&id=30c2e244&"
import script from "./DataFiltro.vue?vue&type=script&lang=js&"
export * from "./DataFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports